import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { AmbassadorLoginDTO } from '../../../models/ambassador-login-dto';

@Component({
  selector: 'ambassador-email-login',
  templateUrl: './ambassador-email-login.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})

export class AmbassadorEmailLoginComponent implements OnInit {

    @Input() idAmbassador: string;
  loginform: FormGroup;
  otpform: FormGroup;
  model: AmbassadorLoginDTO = new AmbassadorLoginDTO();
  submitted = 0;
  submittedOtp = 0;
  submitText = "Conectarse";
  loading = false;
  loginStatus = true;
  otpStatus = true;
  emailSent = false;
  registrationNeeded = false;
  countOtpFailed = 0;
  invalidUser = false;

  constructor(
    private router: Router,
    private authJwtService: AuthJwtService
  ) {
  }

  ngOnInit(): void {
    this.loginform = new FormGroup({
        User: new FormControl(null, [Validators.required, Validators.email, Validators.maxLength(250)]),
        IdAmbassador: new FormControl(this.idAmbassador, [Validators.required])
      });

      this.otpform = new FormGroup({
        OtpCode: new FormControl(null, [Validators.required, Validators.maxLength(6), Validators.minLength(6)])
      });
  }

  send() {
    this.submitted = 1;
    if (this.loginform.invalid) return;
    this.Login();
  }

  Login() {
    this.loading = true;
    this.model = this.loginform.value;
    this.authJwtService.loginAmbassador(this.model).subscribe((resp) => {
      this.loading = false;
      if (resp.InvalidUser) {
        this.invalidUser = true;
      }
      else {
        this.registrationNeeded = true;
      }
    }, (err) => {
      this.submitted = 0;
      this.loginStatus = false;
      this.loading = false;
    });
  }

  LoginOtp() {

    this.submittedOtp = 1;
    if (this.otpform.invalid) return;
    this.loading = true;

    this.model.User = this.loginform.controls['User'].value;
    this.model.OtpCode = this.otpform.controls['OtpCode'].value;
    this.model.IdAmbassador = this.idAmbassador;

    this.authJwtService.loginOtpAmbassador(this.model).subscribe((resp) => {
        this.loading = false;
        if(resp.InvalidOtp) {
            this.otpStatus = false;
            this.countOtpFailed++;
            this.submittedOtp = 0;
            this.loading = false;
        } else {
            this.otpStatus = true;
            window.localStorage.setItem('idAmbassador', this.idAmbassador);
            this.router.navigateByUrl('/ambassador-home');
        }
    }, (err) => {
      this.countOtpFailed++;
      this.otpStatus = false;
      this.submittedOtp = 0;
      this.loading = false;
    });
  }

  resetAll() {
    this.loading = false;
    this.loginStatus = true;
    this.otpStatus = true;
    this.emailSent = false;
    this.registrationNeeded = false;
    this.countOtpFailed = 0;
    this.invalidUser = false;
    this.otpform.controls['OtpCode'].setValue(null);
  }

}

